import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useOutletContext } from 'react-router';
import { Link } from 'react-router-dom';
import sumDataIcon_on from '../../images/sumDsIcon_on.png';
import sumDataIcon_off from '../../images/sumDsIcon_off.png';
import monitoringIcon_on from '../../images/rawDsIcon_on.png';
import monitoringIcon_off from '../../images/rawDsIcon_off.png';
import modelIcon_on from '../../images/model_on.png';
import modelIcon_off from '../../images/model_off.png';
import userRankIcon_on from '../../images/userRank_on.png';
import userRankIcon_off from '../../images/userRank_off.png';
import './dataStructure.scss';
import axios from 'axios';
import { API_URL } from '../../config/constants';
import { useSelector } from 'react-redux';

function DataStructure(props) {
    const { pathname } = useLocation();
    const [sumDsArr, setSumDsArr] = useState([]);
    const [selSumDsId, setSelSumDsId] = useState(-1);
    const { privilege, userRank } = useSelector((state) => state.session);
    async function getStructs() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getStructs`);
        const sumDs = response.data.sumDs;
        console.log(sumDs)
        setSumDsArr([...sumDs]);
        setSelSumDsId(sumDs.length > 0 ? sumDs[0].sumDsId : -1);
    }

    const lastPathName = pathname.split('/')[3];

    const onClickSumDs = (e, id) => {
        e.preventDefault();
        setSelSumDsId(id);
    };

    useEffect(() => {
        getStructs();
    }, [])
    useEffect(() => {
        if (lastPathName === 'sumData' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        } else if (lastPathName === 'monitoring' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        }
    }, [lastPathName, sumDsArr]);
    console.log(userRank)
    return (
        <div className='dsPage'>
            <div className='dsMenuArea'>
                <ul className='dsMenuUl'>
                    <li className='dsMenuLi'>
                        <Link className={pathname.split('/')[3] === 'sumData' ? 'dsMenuBtn on' : 'dsMenuBtn'} to={'/home/dataStructure/sumData'}>
                            <div className='dsMenuIconArea'>
                                <img className='dsMenuIcon' src={pathname.split('/')[3] === 'sumData' ? sumDataIcon_on : sumDataIcon_off} alt={"공정 요약"} />
                            </div>
                            <span>요약 데이터 구조</span>
                        </Link>
                    </li>
                    <li className='dsMenuLi'>
                        <Link className={pathname.split('/')[3] === 'monitoring' ? 'dsMenuBtn on' : 'dsMenuBtn'} to={'/home/dataStructure/monitoring'}>
                            <div className='dsMenuIconArea'>
                                <img className='dsMenuIcon' src={pathname.split('/')[3] === 'monitoring' ? monitoringIcon_on : monitoringIcon_off} alt={"세부 데이터"} />
                            </div>
                            <span>세부 데이터 구조</span>
                        </Link>
                        {
                            lastPathName === 'monitoring' ?
                                <ul className='subMenuUl'>
                                    {
                                        sumDsArr.map((el, sumDsIdx) => (
                                            <li key={`sumDs_mon_${sumDsIdx}`}>
                                                <button onClick={e => onClickSumDs(e, el.sumDsId)} disabled={selSumDsId === el.sumDsId}>{el.name}</button>
                                            </li>
                                        ))
                                    }
                                </ul>
                                : null
                        }
                    </li>
                    <li className='dsMenuLi'>
                        <Link className={lastPathName === 'model' ? 'dsMenuBtn on' : 'dsMenuBtn'} to={'/home/dataStructure/model'} disabled={!privilege?.model.read}>
                            <div className='dsMenuIconArea'>
                                <img className='dsMenuIcon' src={lastPathName === 'model' ? modelIcon_on : modelIcon_off} alt={"모델"} />
                            </div>
                            <span>모델</span>
                        </Link>
                    </li>
                    <li className='dsMenuLi'>
                        <Link className={lastPathName === 'userRank' ? 'dsMenuBtn on' : 'dsMenuBtn'} to={'/home/dataStructure/userRank'} disabled={!privilege?.userRank.read}>
                            <div className='dsMenuIconArea'>

                                <img className='dsMenuIcon' src={lastPathName === 'userRank' ? userRankIcon_on : userRankIcon_off} alt={"유저 랭크"} />
                            </div>
                            <span>유저 랭크</span>
                        </Link>
                    </li>
                    <li className='dsMenuLi'>
                        <Link className={lastPathName === 'organization' ? 'dsMenuBtn on' : 'dsMenuBtn'} to={'/home/dataStructure/organization'} disabled={userRank > 10}>
                            <div className='dsMenuIconArea'>
                                <img className='dsMenuIcon' src={lastPathName === 'organization' ? userRankIcon_on : userRankIcon_off} alt={"조직"} />
                            </div>
                            <span>조직</span>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className='dsContentArea'>
                <Outlet context={{ selSumDsId }} />
            </div>
        </div>
    );
}

export default DataStructure;